import { render, staticRenderFns } from "./alarmCamera.vue?vue&type=template&id=68bf9cc2&scoped=true"
import script from "./alarmCamera.vue?vue&type=script&lang=js"
export * from "./alarmCamera.vue?vue&type=script&lang=js"
import style0 from "./alarmCamera.vue?vue&type=style&index=0&id=68bf9cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf9cc2",
  null
  
)

export default component.exports